import React, {useContext} from "react";
import {getName, removeUserSession} from '../../storage/user';
import {withRouter} from "react-router-dom";
import {LoggedInContext} from "../../index";

function Logout(props) {
    let loggedInContext = useContext(LoggedInContext);

    const handleLogout = () => {
        removeUserSession();
        loggedInContext.toggleLoggedIn();
        props.history.push('/login');
    }

    if(getName()) {
        return (
            <form className="nav-item form-inline my-2 my-lg-0" id="navbar">
                <p className="nav-item navlink-color pr-3 my-2 my-sm-0">{getName()}</p>
                <button className="btn btn-sm btn-outline-light my-2 my-sm-0 navlink-color"
                        onClick={handleLogout}>Logout</button>
            </form>
        )
    } else {
        return <></>
    }
}

export default withRouter(Logout);